import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const requestShippingDeliveryPermissions = {
  name: "requestShippingDeliveryPermissions" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.null(),
};
